<script lang="ts">
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import fillingImage from "../../../../core/assets/icons/filling.svg";
	import plus from "../../../../core/assets/icons/btn-plus.svg?raw";
	import Button from "../Button.svelte";
	import ProductOptionHeader from "./ProductOptionHeader.svelte";
	import { calculatePriceForProductOption } from "../../../../core/schema/utils/calculatePriceForProductOption.js";
	import { ProductOption } from "../../../../core/schema/ProductOption.js";
	import { ProductFilling } from "../../../../core/schema/ProductFilling.js";
	import { productFillingNameMap } from "../../../../core/schema/names/productFillingNameMap.js";
	import { productFillingColorMap } from "../../../../core/schema/productFillingColorMap.js";

	export let filling: ProductFilling | undefined;
	export let updateFilling: (color: ProductFilling | undefined) => void;
	export let basePrice: number;
	export let minimalPricesForOptions: Record<ProductOption, number>;
	export let changed: boolean | undefined;

	function onChange(_filling: typeof filling): void {
		if (changed === undefined) {
			changed = false;
			return;
		}
		changed = true;
	}
	$: onChange(filling);

	const { TENANT_LOCALE } = getGlobalSettings();

	$: minimalPrice = minimalPricesForOptions[ProductOption.Filling];
	$: currentPrice = calculatePriceForProductOption(basePrice, ProductOption.Filling, filling);

	const orderedFillings: { [TKey in ProductFilling]: TKey } = {
		[ProductFilling.FruityLight]: ProductFilling.FruityLight,
		[ProductFilling.FruityDark]: ProductFilling.FruityDark,
		[ProductFilling.ChocolateWithRaspberries]: ProductFilling.ChocolateWithRaspberries,
		[ProductFilling.ChocolateWithSaltedCaramel]: ProductFilling.ChocolateWithSaltedCaramel,
		[ProductFilling.LemonWithRaspberries]: ProductFilling.LemonWithRaspberries,
		[ProductFilling.PistachioWithRaspberries]: ProductFilling.PistachioWithRaspberries,
	};
</script>

<ProductOptionHeader name="Náplň" image={fillingImage} price={currentPrice} {minimalPrice} minimalPriceIsFinal>
	Vyberte si náplň Vašeho dortu. S našimi cukráři jsme vyladili chutě všech možností, proto s žádnou volbou nešlápnete
	vedle.
</ProductOptionHeader>

<div class="flex flex-col gap-[.125rem] sm:gap-1.5">
	{#each Object.values(orderedFillings) as value}
		{@const id = `filling-${value}`}
		{@const selected = filling === value}
		<label
			for={id}
			class="relative flex h-10 cursor-pointer items-center justify-center rounded-md border-2 border-white text-[0.625rem] font-bold uppercase leading-4 text-secondary outline-2 outline-secondary {productFillingColorMap[
				value
			]}"
			class:outline={selected}
		>
			<input
				type="radio"
				{id}
				name="filling"
				class="pointer-events-none absolute inset-0 opacity-0"
				{value}
				bind:group={filling}
				required
			/>
			{productFillingNameMap[value][TENANT_LOCALE]}
		</label>
	{/each}
</div>

<Button
	icon={plus}
	iconClass="w-5 h-5"
	class="ml-auto mt-6"
	on:click={() => {
		updateFilling(filling);
	}}
>
	Uložit úpravu
</Button>
